 import { useState, useEffect, useCallback } from 'react';

// Cart functionality using cookies
class CartManager {
    constructor() {
        this.cookieName = 'shopping_cart';
        this.cart = [];
        this.useLocalStorage = false;
        
        this.init();
    }

    init() {
        const cookieSupported = this.checkCookieSupport();
        
        if (!cookieSupported) {
            this.useLocalStorage = true;
        }
        
        this.loadCart();
    }

    loadCart() {
      
        let cartData = null;
        
        if (this.useLocalStorage) {
           
            cartData = localStorage.getItem(this.cookieName);
        } else {
          
            cartData = this.getCookie(this.cookieName);
         
            
            if (!cartData) {
             ;
                cartData = localStorage.getItem(this.cookieName);
                if (cartData) {
                 
                    this.useLocalStorage = true;
                }
            }
        }
        
        
        
        if (cartData) {
            try {
                const parsed = JSON.parse(cartData);
               
                
                const filteredCart = parsed.filter(item => {
                    if (!item) {
                       
                        return false;
                    }
                    if (!item.spuId || item.spuId === 'undefined') {
                     
                        return false;
                    }
                    if (!item.skuId || item.skuId === 'undefined') {
                       
                        return false;
                    }
                   
                    return true;
                });
                
               
                this.cart = filteredCart;
            } catch (error) {
             
                this.cart = [];
            }
        } else {
          
            this.cart = [];
        }
        
       
    }

    saveCart() {
     
        const cartData = JSON.stringify(this.cart);
      
        
        if (this.useLocalStorage) {
           
            localStorage.setItem(this.cookieName, cartData);
        } else {
          
            this.setCookie(this.cookieName, cartData, 365);
            
            const savedData = this.getCookie(this.cookieName);
          
            if (savedData !== cartData) {
               
                this.useLocalStorage = true;
                localStorage.setItem(this.cookieName, cartData);
            }
        }
        
        // Dispatch custom event for cart updates
      
        window.dispatchEvent(new CustomEvent('cartUpdated', { detail: this.cart }));
    }

    addToCart(spuId, skuId, quantity = 1, selectedSize = null, selectedColor = null, country = null) {
    
        
        if (!spuId || spuId === 'undefined') {
         
            return false;
        }
        
        if (skuId === 'undefined') {
          
            return false;
        }
        
        if (quantity <= 0) {
           
            return false;
        }

        const existingIndex = this.cart.findIndex(item => 
            item.spuId === spuId && 
            item.skuId === skuId &&
            item.size === selectedSize &&
            item.color === selectedColor &&
            item.country === country
        );
        
      
        
        if (existingIndex !== -1) {
           
            this.cart[existingIndex].quantity += quantity;
        } else {
           
            const newItem = {
                spuId,
                skuId,
                quantity,
                size: selectedSize,
                color: selectedColor,
                country: country,
                addedAt: new Date().toISOString()
            };
          
            this.cart.push(newItem);
        }
        
       
        this.saveCart();
        return true;
    }

    removeFromCart(index) {
        if (index >= 0 && index < this.cart.length) {
            const removed = this.cart.splice(index, 1)[0];
            this.saveCart();
            return removed;
        }
        return null;
    }

    updateQuantity(index, quantity) {
        if (quantity <= 0) {
            this.removeFromCart(index);
        } else if (index >= 0 && index < this.cart.length) {
            this.cart[index].quantity = quantity;
            this.saveCart();
        }
    }

    getTotal() {
        return this.cart.reduce((sum, item) => {
            const price = item.price || 0;
            const quantity = item.quantity || 0;
            return sum + (price * quantity);
        }, 0);
    }

    getCount() {
        return this.cart.reduce((count, item) => {
            return count + (item.quantity || 0);
        }, 0);
    }

    clearCart() {
        this.cart = [];
        this.saveCart();
    }

    getCart() {
        return this.cart;
    }

    isInCart(spuId, skuId = null, size = null, color = null) {
        return this.cart.some(item => 
            item.spuId === spuId && 
            item.skuId === skuId &&
            item.size === size && 
            item.color === color
        );
    }

    // Cookie utilities
    setCookie(name, value, days) {
        const expires = new Date();
        expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
        
        let cookieString = `${name}=${value};expires=${expires.toUTCString()};path=/`;
        cookieString += ';SameSite=Lax';
        
        if (window.location.protocol === 'https:') {
            cookieString += ';Secure';
        }
        
        document.cookie = cookieString;
    }

    getCookie(name) {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) {
                return c.substring(nameEQ.length, c.length);
            }
        }
        return null;
    }

    checkCookieSupport() {
        try {
            const testName = 'test_cookie';
            const testValue = 'test';
            
            document.cookie = `${testName}=${testValue};path=/`;
            
            const cookies = document.cookie.split(';');
            const testCookie = cookies.find(cookie => 
                cookie.trim().startsWith(`${testName}=`)
            );
            
            document.cookie = `${testName}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
            
            return testCookie && testCookie.includes(testValue);
        } catch (error) {
            return false;
        }
    }
}

// Global cart manager instance
let cartManagerInstance = null;

const getCartManager = () => {
    if (!cartManagerInstance) {
        cartManagerInstance = new CartManager();
    }
    return cartManagerInstance;
};

export const useCart = () => {
    const [cart, setCart] = useState([]);
    const [cartCount, setCartCount] = useState(0);
    const [cartTotal, setCartTotal] = useState(0);

    const updateCartState = useCallback(() => {
    
        const manager = getCartManager();
        const currentCart = manager.getCart();
    
        
        setCart(currentCart);
        setCartCount(manager.getCount());
        setCartTotal(manager.getTotal());
        
       
    }, []);

    useEffect(() => {
       
        updateCartState();
        
        // Listen for cart updates
        const handleCartUpdate = () => {
          
            updateCartState();
        };
        
        window.addEventListener('cartUpdated', handleCartUpdate);
        
        return () => {
            window.removeEventListener('cartUpdated', handleCartUpdate);
        };
    }, [updateCartState]);

    const addToCart = useCallback((spuId, skuId, quantity = 1, selectedSize = null, selectedColor = null, country = null) => {
       
        const manager = getCartManager();
        const success = manager.addToCart(spuId, skuId, quantity, selectedSize, selectedColor, country);
      
        if (success) {
            updateCartState();
        }
        return success;
    }, [updateCartState]);

    const removeFromCart = useCallback((index) => {
        const manager = getCartManager();
        const removed = manager.removeFromCart(index);
        if (removed) {
            updateCartState();
        }
        return removed;
    }, [updateCartState]);

    const updateQuantity = useCallback((index, quantity) => {
        const manager = getCartManager();
        manager.updateQuantity(index, quantity);
        updateCartState();
    }, [updateCartState]);

    const clearCart = useCallback(() => {
        const manager = getCartManager();
        manager.clearCart();
        updateCartState();
    }, [updateCartState]);

    const isInCart = useCallback((spuId, skuId = null, size = null, color = null) => {
        const manager = getCartManager();
        return manager.isInCart(spuId, skuId, size, color);
    }, []);

    return {
        cart,
        cartCount,
        cartTotal,
        addToCart,
        removeFromCart,
        updateQuantity,
        clearCart,
        isInCart
    };
};

export default useCart;
